import { reduce, round, toNumber } from 'lodash'

export const totalTableMixin = {
  data () {
    return {}
  },
  computed: {
    totalByFiltredRows: function () {
      if (!this.options.totalCalculate || !this.options.totalCalculate.fields || this.filteredItems.length == 0) {
        return false
      }
      let fields = this.options.totalCalculate.fields
      let r = reduce(this.filteredItems, function (result, value, key) {
        for (let k in value) {
          if (fields.includes(k)) {
            result[k] = round(0 + toNumber(result[k] || 0) + toNumber(value[k]), 4)
          }
        }

        return result
      }, {})

      if (this.options?.totalCalculate?.titleField) {
        r[this.options.totalCalculate.titleField] = 'Total:'
      }
      return r
    },
    totalSubGroupByFiltredRows: function () {
      if (!this.options.totalCalculate || !this.options.totalCalculate.subGroup || this.filteredItems.length == 0) {
        return false
      }
      let fields = this.options.totalCalculate.subfields || this.options.totalCalculate.fields
      let subGroup = this.options.totalCalculate.subGroup
      let titleField = this.options?.totalCalculate?.titleField
      let r = reduce(this.filteredItems, function (result, value, key) {
        for (let k in value) {
          if (fields.includes(k)) {
            if (!result[value[subGroup]]) result[value[subGroup]] = {}

            if (titleField && !result[value[subGroup]][titleField]) {
              result[value[subGroup]][titleField] = 'Total:'
            }

            if (!result[value[subGroup]][subGroup]) {
              result[value[subGroup]][subGroup] = value[subGroup]
            }

            result[value[subGroup]][k] = round(0 + toNumber(result[value[subGroup]][k] || 0) + toNumber(value[k] || 0), 4)
          }
        }

        return result
      }, {})

      return Object.values(r)
    },
    totalTableHeader () {
      const totalKeyHeader = [ this.options.totalCalculate.titleField, this.options.totalCalculate.subGroup, ...this.options.totalCalculate.subfields ]
      return totalKeyHeader.map(value => {
        const { text } = this.headers.find(({ value: valueHeader }) => valueHeader === value)
        return { text, value }
      })
    },
  },
  methods: {}
}
